<template>
  <section class="form-sec">
    <div class="container-fluid">
      <div class="search-form-area">
        <div class="row">
          <div class="col-xs-12 col-lg-3 text-center text-lg-left form-heading">
            <h4 class="h3">Search</h4>
            <p>
              To begin, <b>choose</b> the options that best fit your startup
            </p>
          </div>
          <div class="col-xs-12 col-lg-9 form-all">
            <div class="form-all-in m-auto">
              <form v-on:submit.prevent="runSearch">
                <div class="row compact">
                  <div class="col-xs-12 col-sm-6 col-lg-2">
                    <sectors-drop-down />
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-2">
                    <investor-type-drop-down />
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-2">
                    <capital-type-drop-down />
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-2">
                    <funding-need-drop-down />
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-2 btn-cont">
                    <div class="form-group">
                      <button class="btn btn-success">Submit</button>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group">
                      <female-focus-radio />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectorsDropDown from "./SectorsDropDown.vue";
import InvestorTypeDropDown from "./InvestorTypeDropDown.vue";
import CapitalTypeDropDown from "./CapitalTypeDropDown.vue";
import FundingNeedDropDown from "./FundingNeedDropDown.vue";
import FemaleFocusRadio from "./FemaleFocusRadio.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "SearchBar",
  components: {
    "sectors-drop-down": SectorsDropDown,
    "investor-type-drop-down": InvestorTypeDropDown,
    "capital-type-drop-down": CapitalTypeDropDown,
    "funding-need-drop-down": FundingNeedDropDown,
    "female-focus-radio": FemaleFocusRadio
  },
  computed: {
    ...mapGetters({
      isFirstSearch: "isFirstSearch",
      results: "results",
      noResults: "noResults"
    })
  },
  methods: {
    ...mapActions({
      search: "search"
    }),
    ...mapMutations({
      setResults: "setResults",
      setFirstSearch: "setFirstSearch",
      setTimeTaken: "setTimeTaken",
      resetNumberResults: "resetNumberResults",
      setIsLoading: "setIsLoading"
    }),
    runSearch: function() {
      this.setResults([]);
      this.setIsLoading(true);
      this.resetNumberResults();
      var timeBefore = performance.now();
      this.search().then(() => {
        this.setTimeTaken(performance.now() - timeBefore);
        if (this.isFirstSearch) {
          this.setFirstSearch(false);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/SearchBar.vue